module.exports = __webpack_public_path__ + "static/media/question.a6fbaf05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/question.svg
// module id = 194
// module chunks = 0